module.exports = __webpack_public_path__ + "static/img/t54.26db3b4a.png";